import $ from 'jquery';

import Products from './Products';

var Navigation = {
    selectors: {
        mobile_header_navbar: $('.navbar-nav--mobile'),
        products_categories_mobile_nav_toggler: $('.nav-link--products-categories-toggler'),
        submenu_products_bar: $('.submenu-products-bar'),
        search_input: $('#search'),
        navbar_toggler: $('.navbar-toggler')
    },

    init: function () {
        this.eventHandler();
        Products.productsCategoriesHandler();
    },

    eventHandler: function () {
        this.productsCategoriesMobileNavigationHandler();
        this.mobileNavbarHandler();
    },

    mobileNavbarHandler: function () {
        var selectors = this.selectors;

        selectors.mobile_header_navbar.find('.nav-item').click(function () {
            if ($(this).hasClass('nav-item--search-mobile')) {
                $('.products-categories-mobile-nav--open').removeClass('products-categories-mobile-nav--open');
                selectors.submenu_products_bar.toggleClass('submenu-products-bar--opened');
                $('body').removeClass('modal-open');
                selectors.search_input.focus();
                Navigation.closeOpenedMobileNav();
            }

            if ($(this).hasClass('usermenu')) {
                $('.products-categories-mobile-nav--open').removeClass('products-categories-mobile-nav--open');
                Navigation.closeOpenedMobileNav();
            }
        });

        // On click to toggle mobile nav we close all others opened or
        // collapsed containers - products categories or search bar
        selectors.navbar_toggler.click(function() {
            $('#productsCategoriesSidenav').removeClass('products-categories-mobile-nav--open');
            selectors.submenu_products_bar.removeClass('submenu-products-bar--opened');
            $('body').removeClass('modal-open');
        })
    },

    productsCategoriesMobileNavigationHandler: function () {
        var selectors = this.selectors;

        selectors.products_categories_mobile_nav_toggler.click(function () {
            $(`#${$(this).data('toggle')}`).toggleClass('products-categories-mobile-nav--open');
            selectors.submenu_products_bar.removeClass('submenu-products-bar--opened');
            $('body').toggleClass('modal-open');
            Navigation.closeOpenedMobileNav();
        });

        $(window).resize(function () {
            if ($(window).width() > 991) {
                if ($('.products-categories-mobile-nav--open').length > 0) {
                    $('.products-categories-mobile-nav--open').removeClass('products-categories-mobile-nav--open');
                    $('body').removeClass('modal-open');
                }
            }
        });
    },

    closeOpenedMobileNav: function () {
        var selectors = this.selectors;
        selectors.navbar_toggler.addClass('collapsed');
        $('#navbarSupportedContent').removeClass('show');
    }
}

export default Navigation;
